import React from "react";
import { motion } from "framer-motion";
import { Users, Award, Gavel, TrendingUp } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const AuctionStats = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const statsData = labels.menuPages?.sellCar?.auctionStats?.stats || [];

  const icons = [
    <Users className="w-8 h-8 text-blue-500" />,
    <TrendingUp className="w-8 h-8 text-green-500" />,
    <Award className="w-8 h-8 text-purple-500" />,
    <Gavel className="w-8 h-8 text-orange-500" />,
  ];

  const stats = statsData.map((stat: any, index: number) => ({
    icon: icons[index] || icons[0],
    number: stat.number || "",
    label: stat.label || "",
    description: stat.description || "",
  }));

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
      {stats.map((stat, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: index * 0.1 }}
          viewport={{ once: true }}
          className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center"
        >
          <div className="flex justify-center mb-4">{stat.icon}</div>
          <div className="text-3xl font-bold mb-2 text-gray-900">
            {stat.number}
          </div>
          <div className="text-lg font-semibold mb-2 text-gray-700">
            {stat.label}
          </div>
          <div className="text-sm text-gray-500">{stat.description}</div>
        </motion.div>
      ))}
    </div>
  );
};

export default AuctionStats;
